import { jsx } from 'react/jsx-runtime';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { preventForwardPropsConfig } from '@fabric-app/ui/utils/preventForwardProps';
import { isTruthy } from '@fabric-app/utils/guards';
import { motion } from 'framer-motion';
import { useMemo, useState } from 'react';
import { styled, css } from 'styled-components';

const ResizeHandles = ({ columnsConfig, setColumnSize, highlightedHandleId }) => {
  const items = useMemo(() => {
    return columnsConfig.map(({ width, resizable, id }) => {
      return {
        size: width,
        id,
        resizable
      };
    }).filter(isTruthy);
  }, [
    columnsConfig
  ]);
  const [initialSize, setInitialSize] = useState(0);
  const [pannedId, setPannedId] = useState(null);
  return /* @__PURE__ */ jsx(ResizeHandlesContainer, {
    children: items.map(({ size, id, resizable }, index) => /* @__PURE__ */ jsx("div", {
      "data-vdt-item-col": index,
      children: resizable && /* @__PURE__ */ jsx(ResizeHandle, {
        "data-multiselect-clear": true,
        "data-vdt-resize-handle-id": id,
        active: pannedId === id && !highlightedHandleId || highlightedHandleId === id,
        onPan: (e, info) => {
          e.stopPropagation();
          setColumnSize(id, Math.max((initialSize || size) + info.offset.x, 100));
        },
        onPanStart: () => {
          setInitialSize(size);
          setPannedId(id);
        },
        onPanEnd: () => {
          setInitialSize(0);
          setPannedId(null);
        }
      })
    }, index))
  });
};
const ResizeHandlesContainer = styled.div.withConfig({
  displayName: "ResizeHandles__ResizeHandlesContainer",
  componentId: "sc-86577c65-0"
})([
  `position:sticky;width:100%;height:0;left:0;top:0;z-index:21;& div[data-vdt-item-col]{height:1px;position:relative;}display:flex;`
]);
const ResizeHandle = styled(motion.div).withConfig(preventForwardPropsConfig([
  "active"
])).withConfig({
  displayName: "ResizeHandles__ResizeHandle",
  componentId: "sc-86577c65-1"
})([
  `position:absolute;top:0;right:-1px;height:var(--container-height);width:2px;z-index:50;transform:translateX(-50%);transition:0.2s all;&:hover{background:`,
  `;cursor:col-resize;}`,
  ` &:before{position:absolute;content:'';inset:-5px;display:block;cursor:col-resize;}`
], cssVar["color-app-primary"], (p) => p.active && css([
  `background:`,
  `;cursor:col-resize;body{cursor:col-resize;}`
], cssVar["color-app-primary"]));

export { ResizeHandles };
//# sourceMappingURL=ResizeHandles.js.map
